import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classname';
import { Space } from 'antd';

export const IconWithText = ({ icon: Icon, text, className, ...props }) => (
  <Space {...props} className={cls('text-with-icon', className)}>
    {Icon()}
    <span>{text}</span>
  </Space>
);

IconWithText.propTypes = {
  icon: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default IconWithText;
